<template>
  <div class="home-box">
    <!-- {{secondId}},{{secondActiveIndex}} -->
    <div class="second-menu-box">
      <div class="menu-box box-container">
        <div
          @click="clickSecondMenu(index, item.id)"
          :class="secondActiveIndex === String(index) ? 'active-box-item box-item' : 'box-item'"
          v-for="(item, index) in secondMenuListSpe"
          :key="item.id + index"
        >
          <icon-menu :index="index" :item="item"></icon-menu>
        </div>
      </div>
      <!-- 导航 -->
      <el-breadcrumb class="bread-box" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">主页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: `/class/first/${this.firstActiveIndex}/${this.firstId}/second/0/${secondMenuListSpe[0].id}` }">{{ firstMenuMapMutation[firstId].name }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ secondMenuMapMutation[secondId].name }}</el-breadcrumb-item>
      </el-breadcrumb>
      <!-- 二级导航有轮播图 -->
      <el-row
        class="has-picture-box"
        v-if="secondMenuMapMutation && secondMenuMapMutation[secondId].imageListFormatter.length > 0 && currentType === '6'"
      >
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <el-carousel class="picture-slider-box" height="4.6rem" :interval="5000" arrow="always">
            <el-carousel-item
              v-for="(item, index) in secondMenuMapMutation[secondId].imageListFormatter"
              :key="item + index"
            >
              <img :src="baseImageUrl + item" />
            </el-carousel-item>
          </el-carousel>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <contentBox :hasPicture="true" :styleType="String(currentType)" :content="currentDataContent"></contentBox>
        </el-col>
      </el-row>
      <!-- 二级导航轮播图 -->
      <el-row v-else>
        <contentBox :styleType="String(currentType)" :content="currentDataContent"></contentBox>
      </el-row>
      <!-- 首页 -->
      <el-row v-if="firstActiveIndex === '0' && firstMenuMapMutation[firstId].name === '首页' && secondActiveIndex === '0'">
        <div class="main-product-box">
          <div class="main-product-title">公司简介</div>
          <div class="main-product-content">
            南京先河工程技术股份有限公司是一家成立于2018年4月19日的股份制企业，主要从事冶金工程咨询与设计、智能制造、新材料开发与生产以及环保技术应用于推广，是一家高科技型工程技术企业。
          </div>
        </div>
        <div class="main-buju-box">
          <div class="item-title">四大板块</div>
          <div class="main-buju-item">
            <div class="item-content">冶金工程咨询与设计</div>
            <div class="item-content">控冷智能装备</div>
            <div class="item-content">新材料开发与生产</div>
            <div class="item-content">环保技术与应用推广</div>
          </div>
          <!-- <div class="item-title">多远发展</div>
          <div class="main-buju-item">
            <div class="item-content">设备制造</div>
            <div class="item-content">冶金、房建市政全过程、全产业链咨询、监理</div>
            <div class="item-content">信息化、智能化</div>
            <div class="item-content">新能源</div>
          </div> -->
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
// export function transformType(type) {
//   if (type === 0) return '无样式';
//   if (type === 1) return '富文本';
//   if (type === 2) return '图片列表';
//   if (type === 3) return '图片轮播';
//   if (type === 4) return '富文本卡片';
//   if (type === 5) return '多链接列表';
//   if (type === 6) return '富文本列表';
//   if (type === 7) return '文字和图';
//   if (type === 8) return '任务职务列表';
// }
import { mapGetters, mapActions } from 'vuex';
import { dotdot } from '../utils/common';
import iconMenu from '../components/icon-menu';
import contentBox from '../pages/content';
export default {
  name: 'secondClass',
  data() {
    return {
      routerName: this.$route.name,
      // activeIndex: this.$route.params.activeIndex || '0',
      // firstId: this.$route.params.id,

      firstActiveIndex: this.$route.params.firstActiveIndex || '0',
      firstId: this.$route.params.firstId,
      secondActiveIndex: this.$route.params.secondActiveIndex || '0',
      secondId: this.$route.params.secondId,

      menuDataList: {},
      currentDataImage: [],

      currentType: '',
      currentDataContent: {},

      articleListData: [],
      articleTotal: 0,
      pagination: {
        page: 1,
        pageSize: 10,
      },
      // spec
      secondMenuListSpe: [] 

    };
  },
  components: {
    iconMenu,
    contentBox,
  },
  computed: {
    ...mapGetters([
      'systemName',
      'baseImageUrl',
      'firstMenuMutation',
      'firstMenuMapMutation',
      'secondMenuMutation',
      'secondMenuMapMutation',
      'thirdMenuMutation',
      'thirdMenuMapMutation',
    ]),
  },
  created() {
    this.initData();
  },
  mounted() {
    // console.log(this.secondMenuMapMutation, '777777777')
    // console.log(this.activeIndex, this.menuListData, 'this.activeIndex');
  },
  watch: {
    $route(to, from) {
      console.log('66666666666666666======');
      console.log(this.secondMenuMapMutation[this.secondId], '777777777');
      this.secondActiveIndex = this.$route.params.secondActiveIndex;
      this.secondId = this.$route.params.secondId;
    },
  },
  methods: {
    ...mapActions(['menuIdContent', 'getRichTextContentPage']),
    initData() {
      this.menuIdContent({ id: this.firstId }).then((res) => {
        if (res.success) {
          console.log(res, 'currentType===');
          if (res.data.styleType === -1) {
            this.secondMenuListSpe = res.data.data;
            this.menuIdContent({ id: this.secondId }).then((res) => {
              if (res.success) {
                this.currentType = String(res.data.styleType);
                if (this.currentType === '7') {
                  this.currentDataContent = res.data;
                } else if (this.currentType === '2' || this.currentType === '3' || this.currentType === '8') {
                  this.currentDataContent = {
                    data: res.data.data
                  }
                } else if (this.currentType === '1' || this.currentType === '4' || this.currentType === '5' || this.currentType === '6') {
                  this.currentDataContent = res.data.data;
                } else {
                  this.currentDataContent = res.data.data;
                }
              }
            })
          } else {
            this.currentType = String(res.data.styleType);
            if (this.currentType === '7') {
              this.currentDataContent = res.data;
            } else if (this.currentType === '2' || this.currentType === '3' || this.currentType === '8') {
              this.currentDataContent = {
                data: res.data.data
              }
            } else if (this.currentType === '1' || this.currentType === '4' || this.currentType === '5' || this.currentType === '6') {
              this.currentDataContent = res.data.data;
            } else {
              this.currentDataContent = res.data.data;
            }
          }
        }
      });
    },
    clickSecondMenu(index, secondId) {
      this.$router.push(
        `/class/first/${this.firstActiveIndex}/${this.firstId}/second/${index}/${secondId}`,
      );
      console.log(secondId, 'secondId');
      this.secondActiveIndex = String(index);
      this.menuIdContent({ id: secondId }).then((res) => {
        console.log(res, 'saucxs========data');
        if (res.success) {
          this.currentType = String(res.data.styleType);
          if (this.currentType === 'IMAGE_TXT') {
            this.currentDataContent = res.data;
          } else {
            this.currentDataContent = res.data.data;
          }
          // this.currentType = res.data.styleType;
          // if (this.currentType === 2) {
          //   this.currentDataImage =
          //     res.data.data.length > 0 &&
          //     res.data.data.map((item) => {
          //       item = this.baseImageUrl + item;
          //       return item;
          //     });
          // } else if (this.currentType === 1) {
          //   this.currentDataContent = res.data.data;
          // } else if (this.currentType === 'TABLE_PAGE') {
          //   this.articleListData = res.data.data.records;
          //   this.articleTotal = res.data.data.total;
          // }
        }
      });
    },
    goArticleContent(articleId) {
      this.$router.push(`/article/${this.firstActiveIndex}/${this.firstId}/${articleId}`);
    },
    // 表格分页
    handleCurrentChange(val) {
      this.getRichTextContentPage({ menuId: this.secondId, pageSize: 10, pageNo: val }).then(
        (res) => {
          if (this.currentType === 'TABLE_PAGE') {
            this.articleListData = res.data.records;
            this.articleTotal = res.data.total;
          }
        },
      );
    },
  },
};
</script>

<style lang="less" scoped>
.home-box {
  width: 100%;
  .content-box {
    font-size: 0.24rem;
    img {
      width: 100% !important;
    }
  }
  .pagenation-box {
    text-align: center;
    margin: 0.2rem 0;
  }
  .second-menu-box {
    .box-container {
      display: flex;
      justify-content: flex-start;
      .box-item {
        display: flex;
        flex-direction: column;
        cursor: pointer;
        padding: 0.2rem;
        margin: 0 0.2rem 0.2rem 0;
        text-align: center;
        .icon-middle {
          margin: 0 auto;
        }
      }
      .active-box-item {
        text-align: center;
        border-bottom: 2px solid #409eff;
        color: #409eff;
      }
      .font-menu {
        font-size: 0.24rem;
        font-weight: bold;
      }
    }
    // 图片列表
    .image-box,
    .article-content-list-box {
      padding: 0.4rem 0rem;
      .image-item-box {
        padding: 0.14rem;
        // margin: 0 0.2rem 0.2rem 0;
      }
      .article-item-box {
      }
      .image-item {
        width: 100%;
      }
    }
    // 富文本
    .rich-content-box {
      padding: 0.2rem;
    }
    .title-name {
      text-align: center;
      font-size: 0.4rem;
    }
    .flex-box {
      display: flex;
      justify-content: space-around;
      font-size: 0.22rem;
      color: #949494;
    }
    .box-list-style {
      padding: 0.16rem;
      cursor: pointer;
      height: 2rem;
    }
    .title-box {
      font-size: 0.24rem;
      font-weight: bold;
      margin-bottom: 0.2rem;
      color: #409eff;
    }
    .box-item-content {
      font-size: 0.2rem;
    }
    .box-list-style:hover {
      background: #eee;
      color: #409eff;
    }
    // 有轮播图的picture
    .picture-slider-box {
      margin-bottom: 0.2rem;
    }
    .has-picture-box {
      padding: 0.3rem 0;
      img {
        width: 100%;
        height: 4.6rem;
      }
      .box-list-style {
        padding: 0 0.1rem 0.2rem;
      }
      .article-content-list-box {
        padding: 0 0 0 0.2rem;
      }
      .box-list-style {
        height: auto;
      }
      .time-box {
        font-size: 0.14rem;
        font-weight: inherit;
        color: #797979;
        margin-bottom: 0.06rem;
      }
      .title-box {
        margin-bottom: 0;
        font-size: 0.22rem;
        font-weight: inherit;
      }
      .pagenation-box {
        text-align: center;
        margin: 0.1rem 0;
      }
    }
    .main-product-box {
      margin-top: 0.6rem;
      .main-product-title {
        font-size: 0.4rem;
        text-align: center;
        margin-bottom: 0.24rem;
      }
      .main-product-content {
        font-size: 0.22rem;
        padding: 0.4rem;
        background: #f5f5f5;
        border-radius: 0.1rem;
      }
    }
    .main-buju-box {
      margin-top: 1rem;
      .item-title {
        font-size: 0.4rem;
        text-align: center;
        margin-bottom: 0.24rem;
        // color: #409eff;
      }
      .main-buju-item {
        display: flex;
        margin-bottom: 0.8rem;
        justify-content: space-evenly;
        flex-wrap: wrap;
        .item-content {
          font-size: 0.33rem;
          padding: 0.4rem;
          background: #f9f9f9;
          border-radius: 0.1rem;
          width: 3rem;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 0.3rem;
        }
        .item-content:hover {
          background: #409eff;
          color: #fff;
        }
      }
    }
  }
}
</style>
